import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import dataTableGrid from "../DataTableGrid";
import { getSurveyDraftAndReportapprovalList } from "../../Utils/adminFunctions";
const SurveyApproval = () => {
  const [listDraftSurvey, setListDraftSurvey] = useState([]);
  useEffect(() => {
    manage_reportsapproval();
  }, []);
  const manage_reportsapproval = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_status", "survey_released");
    const response = await getSurveyDraftAndReportapprovalList(bodyFormData);
    if (response.status === "success") {
      setListDraftSurvey(response.data);
      dataTableGrid({
        data_table_id: "#userlist",
        paginate: false,
        scroller: false,
        copy_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        csv_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        print_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        sort_option: [25],
      });
    } else if (response.status === "failure") {
      toast.error(response, { autoClose: 1500 });
    }
  };
  return (
    <div className="wrapper">
      <div>
        <ToastContainer></ToastContainer>
        <AdminHeader />
        <AdminNavigation />
        <div className="content-wrapper">
          <div className="content-header"></div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="row">
                        <div className="col-md-8">
                          <h3 className="card-title card-header-link custom-link-primary">
                            <b>Survey Report Approval </b>{" "}
                          </h3>
                        </div>
                        <div className="col-md-4"></div>
                      </div>
                    </div>
                    <div className="card-body scroll-doctos table_scroll">
                      <table
                        id="userlist"
                        className="table table-bordered table-striped"
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "10px" }}>S. No.</th>
                            <th>Survey Name</th>
                            <th style={{ width: "10px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listDraftSurvey ? (
                            listDraftSurvey.map((item, i) => (
                              <tr key={++i}>
                                <td>{++i}</td>
                                <td>{item.survey_name}</td>

                                <td>
                                  <Link
                                    to={
                                      "/qa/manufacturer/reports/analysis_report/" +
                                      item.survey_id
                                    }
                                    className="btn btn-sm custom-btn-primary"
                                  >
                                    <i className="fa fa-eye"></i>{" "}
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={5} className="text-center">
                                Result not found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <AdminFooter />
      </div>
    </div>
  );
};
export default SurveyApproval;
